import getClipboardData from './get-clipboard-data';

export default {
  getClipboardData,
};
